module.exports = __webpack_public_path__ + "img/11.71b2d46d.svg";